import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import React, { forwardRef, useImperativeHandle, useState } from "react";
import CancelIcon from "../../../assets/icons/cross-bold-icon.png";
import GlobalButton from "../../../components/button";
import Label from "../../../components/label";
import TextInput from "../../../components/textInput";
import {
  createEquipment,
  updateEquipment,
} from "../../../services/EquipmentApi";
import { handleApiCall } from "../../../utils/helper";
import { addEquipmentValidation } from "../../../utils/Validation";
import AppLoader from "./../../../components/loader/index";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": { padding: theme.spacing(2) },
  "& .MuiPaper-root": {
    width: "600px",
    [theme.breakpoints.down("sm")]: { margin: 12 },
  },
}));

const AddEditEquipmentDialog = forwardRef(({}, ref) => {
  const [open, setOpen] = useState(false);
  const [dialogData, setDialogData] = useState(null);

  const [isLoading, setIsLoading] = useState(false);

  const [inputValues, setInputValues] = useState({
    name: "",
    monthlyPrice: "",
    oneOffCostPrice: "",
  });
  const [inputError, setInputError] = useState({
    name: false,
    monthlyPrice: false,
    oneOffCostPrice: false,
  });

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
      setDialogData(params);

      if (params.type === "edit") {
        const { data } = params;
        setInputValues({
          name: data?.name,
          oneOffCostPrice: data?.oneOffCostPrice,
          monthlyPrice: data?.monthlyPrice,
        });
      }
    },
    disable() {
      handleClose();
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setInputValues({});
  };

  const handleChangeInputValue = (event) => {
    const { name, value } = event.target;
    setInputError((prev) => ({ ...prev, [name]: false }));
    setInputValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleAddEditEquipment = async () => {
    const validate = addEquipmentValidation(inputValues, setInputError);
    if (validate) {
      return;
    }

    if (dialogData?.type === "add") {
      handleApiCall(
        "",
        createEquipment,
        inputValues,
        setIsLoading,
        handleClose,
        dialogData.getData
      );
    } else {
      handleApiCall(
        dialogData?.data?._id,
        updateEquipment,
        inputValues,
        setIsLoading,
        handleClose,
        dialogData.getData
      );
    }
  };

  return (
    <BootstrapDialog onClose={handleClose} open={open}>
      <AppLoader isVisible={isLoading} />
      <Stack
        p={2}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography
          variant="h1"
          fontSize={"1.5rem"}
          fontWeight={500}
          color={"secondary.dark"}
        >
          {dialogData?.type === "add" ? "Add Equipment" : "Edit Equipment"}
        </Typography>
        <IconButton onClick={handleClose}>
          <img src={CancelIcon} alt="cancel-icon" width={25} />
        </IconButton>
      </Stack>
      <DialogContent dividers>
        <Box margin={"auto"}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Label
                title={"Equipment Name"}
                required
                htmlFor={"equipment-name"}
              />
              <TextInput
                id={"equipment-name"}
                type={"text"}
                required
                error={inputError.name}
                helperText={inputError.name && "Equipmemt name is required"}
                defaultStyle={true}
                placeholder={"Enter equipmemt name"}
                value={inputValues.name}
                name={"name"}
                onChange={handleChangeInputValue}
              />
            </Grid>

            <Grid item xs={6}>
              <Label
                title={"One-off Cost Price"}
                required
                htmlFor={"one-off-price"}
              />
              <TextInput
                id={"one-off-price"}
                type={"number"}
                required
                error={inputError.oneOffCostPrice}
                helperText={
                  inputError.oneOffCostPrice && "One-off cost price is required"
                }
                defaultStyle={true}
                placeholder={"Enter one-off cost price"}
                value={inputValues.oneOffCostPrice}
                name={"oneOffCostPrice"}
                onChange={handleChangeInputValue}
              />
            </Grid>

            <Grid item xs={6}>
              <Label
                title={"Monthly Price"}
                required
                htmlFor={"monthly-price"}
              />
              <TextInput
                id={"monthly-price"}
                type={"number"}
                required
                error={inputError.monthlyPrice}
                helperText={
                  inputError.monthlyPrice && "Monthly price is required"
                }
                defaultStyle={true}
                placeholder={"Enter monthly price"}
                value={inputValues.monthlyPrice}
                name={"monthlyPrice"}
                onChange={handleChangeInputValue}
              />
            </Grid>
          </Grid>
        </Box>
      </DialogContent>
      <DialogActions>
        <GlobalButton
          variant={"custom_gradient"}
          handleClickBtn={handleClose}
          title={"Cancel"}
          style={{
            width: 100,
            background: "red !important",
          }}
        />
        <GlobalButton
          variant={"custom_gradient"}
          title={dialogData?.type === "add" ? "Add" : "Update"}
          style={{ width: 100 }}
          handleClickBtn={handleAddEditEquipment}
        />
      </DialogActions>
    </BootstrapDialog>
  );
});

export default AddEditEquipmentDialog;
